import { EXAM_EVENT_EXAMINEE_STATUS_LABEL } from '@exam-center/exam-event-management';
import {
  ExamEventExamineeCertificateStatus,
  ExamResult,
  OrderType,
  type SearchExamEventExamineesWithCertificateStatusAndResultQuery,
} from '@exam-center/graphql';
import { type dataGridSortDirection } from '@shared/components';

import { type ExamEventExamineeResultListRow } from '../../components/exam-event-examinee-result-data-grid';

type DataGridSortDirection = (typeof dataGridSortDirection)[number];

// TODO: move to exam-center common lib
export const ORDER_TYPE: Record<DataGridSortDirection, OrderType> = {
  asc: OrderType.Asc,
  desc: OrderType.Desc,
};

type ExamEventExaminee =
  SearchExamEventExamineesWithCertificateStatusAndResultQuery['ecSearchExamEventExaminees']['examEventExaminees'][number];

function mapExamResult(result: ExamResult | undefined) {
  switch (result) {
    case ExamResult.Passed:
      return 'passed';
    case ExamResult.Failed:
      return 'failed';
    case ExamResult.None:
    default:
      return undefined;
  }
}

function mapCertificateStatus(status: ExamEventExamineeCertificateStatus) {
  switch (status) {
    case ExamEventExamineeCertificateStatus.Sent:
      return 'completed';
    case ExamEventExamineeCertificateStatus.NotSent:
      return 'disabled';
    case ExamEventExamineeCertificateStatus.NonIssued:
    default:
      return undefined;
  }
}

export function mapExamineeResultData(
  examEventExaminee: ExamEventExaminee,
): ExamEventExamineeResultListRow {
  const examineeFullName = [
    examEventExaminee.examinee.title,
    examEventExaminee.examinee.firstName,
    examEventExaminee.examinee.middleName,
    examEventExaminee.examinee.lastName,
  ]
    .filter(Boolean)
    .join(' ');

  return {
    id: examEventExaminee.id,
    seatNumber: examEventExaminee.seatNumber?.toString() ?? '-',
    fullName: examineeFullName,
    examCourseId: examEventExaminee.examCourse.code,
    certificateStatus: mapCertificateStatus(examEventExaminee.certificateStatus),
    status: EXAM_EVENT_EXAMINEE_STATUS_LABEL[examEventExaminee.status],
    result: mapExamResult(examEventExaminee.examEventExamineeResult?.result),
    remark: examEventExaminee.remark ?? '-',
    cancelationReasonCategory: examEventExaminee.cancelationReason,
  };
}
